
import { Record } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, string_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { IconWeight, IconSize, icon, IconName, IconName_$reflection } from "../Icons.js";
import { map as map_1, singleton, tryFind, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { display_grid, fontWeight_fontMedium, fontSize_textSm, margin_mt1, backgroundColor_bgNeutral50, borderRadius_roundedLg, padding_px2, padding_py3, justifyContent_justifyCenter, alignItems_itemsCenter, flexDirection_flexCol, display_flex, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { gap_gap4, md, grid_gridCols2, textColor_textNeutral700, textColor_textPrimary700, textColor_textNeutral500, textColor_textPrimary600, borderColor_borderPrimary400, dark, backgroundColor_bgPrimary50, borderColor_borderPrimary500, HasFocusVisible_ring, hover, backgroundColor_bgSurface, borderColor_borderNeutral200 } from "../TailwindExtensions.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { append, singleton as singleton_1, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { createElement } from "react";

/**
 * An activity tile definition: value key, display label, and associated icon
 */
export class ActivityTile extends Record {
    constructor(Value, Label, Icon) {
        super();
        this.Value = Value;
        this.Label = Label;
        this.Icon = Icon;
    }
}

export function ActivityTile_$reflection() {
    return record_type("Shared.ActivityTileSelector.ActivityTile", [], ActivityTile, () => [["Value", string_type], ["Label", string_type], ["Icon", IconName_$reflection()]]);
}

export const tiles = ofArray([new ActivityTile("custom", "Custom", new IconName(15, [])), new ActivityTile("walking", "Walking", new IconName(8, [])), new ActivityTile("running", "Running", new IconName(9, [])), new ActivityTile("cycling", "Cycling", new IconName(10, [])), new ActivityTile("swimming", "Swimming", new IconName(11, [])), new ActivityTile("reading", "Reading", new IconName(12, [])), new ActivityTile("meditation", "Meditation", new IconName(13, [])), new ActivityTile("exercise", "Exercise", new IconName(14, []))]);

/**
 * Returns the icon name for a given activity value, or Sparkle as fallback
 */
export function iconForValue(value) {
    return defaultArg(map((t_1) => t_1.Icon, tryFind((t) => (t.Value === value), tiles)), new IconName(15, []));
}

/**
 * Returns the display label for a given activity value, or the value itself as fallback
 */
export function labelForValue(value) {
    return defaultArg(map((t_1) => t_1.Label, tryFind((t) => (t.Value === value), tiles)), value);
}

const defaultTileClass = tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, padding_py3, padding_px2, "border", borderColor_borderNeutral200, borderRadius_roundedLg, backgroundColor_bgSurface, "cursor-pointer", "transition-colors", hover(backgroundColor_bgNeutral50), HasFocusVisible_ring]));

const selectedTileClass = tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, padding_py3, padding_px2, "border-2", borderColor_borderPrimary500, borderRadius_roundedLg, backgroundColor_bgPrimary50, dark("bg-primary-900/20"), dark(borderColor_borderPrimary400), "cursor-pointer", "transition-colors", HasFocusVisible_ring]));

function renderTile(selectedValue, onChange, tile) {
    const isSelected = tile.Value === selectedValue;
    return HtmlHelper_createElement("label", ofArray([["data-testid", concat("activity-tile-", tile.Value)], ["className", isSelected ? selectedTileClass : defaultTileClass], ["children", [HtmlHelper_createElement("input", ofArray([["type", "radio"], ["name", "activity-type"], ["value", tile.Value], ["checked", isSelected], ["className", tw(singleton("sr-only"))], ["onChange", (ev) => {
        const _arg = ev.target.checked;
        onChange(tile.Value);
    }]])), HtmlHelper_createElement("div", ofArray([["className", tw(toList(delay(() => (isSelected ? singleton_1(textColor_textPrimary600) : singleton_1(textColor_textNeutral500)))))], ["children", [createElement(icon, {
        name: tile.Icon,
        size: new IconSize(2, []),
        weight: new IconWeight(0, []),
    })]]])), HtmlHelper_createElement("span", ofArray([["className", tw(toList(delay(() => append(singleton_1(margin_mt1), delay(() => append(singleton_1(fontSize_textSm), delay(() => append(singleton_1(fontWeight_fontMedium), delay(() => (isSelected ? singleton_1(textColor_textPrimary700) : singleton_1(textColor_textNeutral700)))))))))))], ["children", singleton(tile.Label)]]))]]]));
}

/**
 * Render the activity tile selector grid.
 * selectedValue: the currently selected theme value (e.g., "walking", "running")
 * onChange: callback when user selects a tile
 */
export function view(selectedValue, onChange) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["radiogroup"])], ["aria-label", "Activity Type"], ["className", tw(ofArray([display_grid, grid_gridCols2, md("grid-cols-4"), gap_gap4]))], ["children", map_1((tile) => renderTile(selectedValue, onChange, tile), tiles)]]));
}

//# sourceMappingURL=ActivityTileSelector.js.map
